<template>
  <div class="chart-container donut">
    <div v-if="!chartData">
      <b-alert variant="warning" show>No data found for the selected options</b-alert>
    </div>
    <div class="chart" :style="chartStyle">
      <canvas :id="elementId"></canvas>
    </div>
  </div>
</template>


<script>
import Chart from '@/lib/mixins/Chart'

export default {
  mixins: [Chart],
  name: 'BarChart',
  props: ['results', 'options'],
  components: { },
  data () {
    return {
      chartType: 'bar',
      itemLinks: [],
      chartOptions: {
        legend: { display: false },
        scales: {
          xAxes: [{
            type: 'category',
            scaleLabel: {
              display: false,
              labelString: 'Y'
            },
            ticks: {
              autoSkip: true,
              autoSkipPadding: 10.5,
              minRotation: 90,
              maxRotation: 90
            }
          }],
          yAxes: [{
            type: 'linear',
            scaleLabel: {
              display: false,
              labelString: 'Y'
            },
            ticks: {
              min: 0,
              maxTicksLimit: 5,
              userCallback: function (label, index, labels) {
                if (Math.floor(label) === label) {
                  return label
                }
              }
            }
          }]
        }
      }
    }
  },
  computed: {
    chartJsData () {
      return {
        labels: this.chartData.labels,
        datasets: this.chartData.datasets
      }
    }
  },
  watch: {
    results: {
      immediate: true,
      handler (oldVal, newVale) {
        this.update()
      }
    },
    options: {
      immediate: true,
      handler (oldVal, newVal) {
        this.update()
      }
    },
    chartData: {
      immediate: true,
      handler (oldVal, newVal) {
        this.draw()
      }
    }
  },
  methods: {
    update () {
      if (this.results != null && this.results.rows.length > 0) {
        var labelColumn = this.results.columns[0]
        var valueColumn = this.results.columns[this.results.columns.length - 1]
        this.chartOptions.scales.xAxes[0].scaleLabel = { display: true, labelString: labelColumn.name }
        this.chartOptions.scales.yAxes[0].scaleLabel = { display: true, labelString: valueColumn.name }
        this.chartData = {
          labels: this.results.rows.map((row) => row[labelColumn.key]),
          datasets: [
            {
              label: valueColumn.name,
              data: this.results.rows.map((row) => row[valueColumn.key]),
              backgroundColor: this.color(0)
            }
          ]
        }
        this.itemLinks = this.results.rows.map((row) => row.link)
      } else {
        this.chartData = null
        this.itemLinks = []
      }
    },
    clickChart (event, item) {
      if (item.length > 0) {
        const index = item[0]._index
        const link = this.itemLinks[index]
        this.selectLink(link)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/BarChart.vue